import { useSelector } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@/components/ui/modal';
import { RootState } from '../../../../store/store';
import { Button } from '@/components/ui/button';

const ClientUpdateRequiredModal = () => {
  const requirement = useSelector(
    (state: RootState) => state.clientUpdate.requirement
  );

  if (!requirement) {
    return null;
  }

  const hardRefresh = () => {
    window.location.reload();
  };

  return (
    <Modal
      open={true}
      onClose={() => {
        return;
      }}
      name="client-update"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      className="modal--glass"
    >
      <ModalHeader className="modal_header">
        <h4>Update Required</h4>
      </ModalHeader>

      <ModalBody className="modal_content">
        <p className="!my-0">
          A new version of the app is available. Refresh to continue.
        </p>
      </ModalBody>

      <ModalFooter className="modal_actions">
        <Button onClick={hardRefresh} context="modal" className="w-full">
          Refresh
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ClientUpdateRequiredModal;
